import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/store/inventories', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/store/inventories/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, itemData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/store/inventories', itemData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, itemData) {
      return new Promise((resolve, reject) => {
        const url = `/store/inventories/${itemData.id}`
        axios
          .put(url, itemData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/store/inventories/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
